/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerLockDto } from '../../models/customer-lock-dto';

export interface GetBillableServiceCustomerLock$Params {
  customerId: number;
}

export function getBillableServiceCustomerLock(http: HttpClient, rootUrl: string, params: GetBillableServiceCustomerLock$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerLockDto>> {
  const rb = new RequestBuilder(rootUrl, getBillableServiceCustomerLock.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerLockDto>;
    })
  );
}

getBillableServiceCustomerLock.PATH = '/customers/{customerId}/billable-services/customer-lock';
